import { render, staticRenderFns } from "./LoginPage.vue?vue&type=template&id=6084e201&scoped=true"
import script from "./LoginPage.vue?vue&type=script&lang=ts"
export * from "./LoginPage.vue?vue&type=script&lang=ts"
import style0 from "./LoginPage.vue?vue&type=style&index=0&id=6084e201&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6084e201",
  null
  
)

export default component.exports